import config from "./config";
import axios from "axios";
import cookie from "react-cookies";

const jwtToken = cookie.load("jwt-token");

export default function configureAxios() {
  axios.defaults.baseURL = config.apiHost;
  axios.defaults.headers.post["Content-Type"] = "application/json";
  if (jwtToken) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${jwtToken.token}`;
  }
}



// WEBPACK FOOTER //
// ./src/config/configureAxios.js